const LoadingCard = () => {
  return (
    <div className="stats-container" style={{}}>
      <h3>Loading...</h3>
    </div>
  );
};

export default LoadingCard;
